import { useState } from "react";
import useMyPrivilege from "Hooks/Privilege/useMyPrivilege";
import { sidebarRoutes } from "Components/sidebarRoutes";
import "./Sidebar.css";
import SidebarTile from "./SidebarTile";
import { useTranslateHelper } from "Lib/useTranslateHelper";
import { useAppSelector } from "Hooks/redux-hooks";
import { UserDetails } from "Interface/businessSetting";
import LoadLink from "Components/Common/Loader/Loadinglink";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const SIDEBAR_WIDTH = "18vw";
  const SIDEBAR_WIDTH_MIN = "80px";
  const { t } = useTranslateHelper();
  const open = useAppSelector((state) => state.toggle.open);

  const [myPrevList, setMyPrivList] = useState<string[]>([]);

  useMyPrivilege((data) => {
    var tempList = data.data.privileges.map((e) => e.privilege_key);
    setMyPrivList([...tempList]);
  });

  const userDetails: UserDetails = useAppSelector((state) =>
    JSON.parse(state.appData.userDetails ?? "{}")
  );
  const { tenant } = userDetails;

  return (
    <div
      className="sidebar"
      style={{
        width: open ? SIDEBAR_WIDTH : SIDEBAR_WIDTH_MIN,
        position: "sticky",
        padding: `2vh ${open ? "1.5vh" : "0.5vh"}`,
      }}
    >
      <div className="sidebar-header" style={{ whiteSpace: "nowrap" }}>
        <p className="sidebar-title space-no-wrap">
          {open ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1.7rem",
                }}
              >
                <div
                  style={{
                    height: "70px",
                    width: "70px",
                    position: "relative",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={tenant?.logo ?? "/public/logo512.png"}
                    alt="Logo"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div
                  style={{
                    flex: 1,
                    // @ts-ignore
                    textWrap: "wrap",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "1rem",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {tenant?.business_name}
                  </h2>
                  <p
                    className="sidebar-subtitle"
                    style={{
                      fontWeight: 500,
                      fontSize: ".6rem",
                    }}
                  >
                    {tenant?.business_category}
                  </p>
                </div>
              </div>
            </>
          ) : (
            t("sidebar.orgShortName")
          )}
        </p>
        {/* {open ? (
          <p className="sidebar-subtitle">{t("sidebar.subtitle")}</p>
        ) : (
          ""
        )} */}
      </div>
      {myPrevList.length !== 0 ? (
        <div className="sidebar-content">
          {sidebarRoutes
            .filter((e) => {
              for (const prev of e.permission) {
                if (myPrevList.includes(`manage_${prev}`)) {
                  return true;
                }
              }
              return false;
            })
            .map((data, index) => {
              if (data.childRoutes) {
                return (
                  <SidebarTile
                    key={index}
                    isOpened={open}
                    title={t(`sidebar.${data.title.toLowerCase()}`)}
                    icon={data.icon}
                    //@ts-ignore
                    childRoutes={data.childRoutes}
                  >
                    {data?.children?.map((child, index) => {
                      return (
                        <SidebarTile
                          key={index}
                          to={child.to}
                          isOpened={open}
                          title={t(`sidebar.${child.title.toLowerCase()}`)}
                          icon={child.icon}
                        />
                      );
                    })}
                  </SidebarTile>
                );
              } else {
                return (
                  <SidebarTile
                    key={index}
                    to={data.to}
                    isOpened={open}
                    title={t(`sidebar.${data.title.toLowerCase()}`)}
                    icon={data.icon}
                  />
                );
              }
            })}
        </div>
      ) : (
        Array(10)
          .fill(0)
          .map((_, index) => {
            return (
              <div>
                <div
                  className="shine"
                  style={{ height: 65, width: "100%", borderRadius: "10px" }}
                  key={index}
                />
              </div>
            );
          })
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "13vh",
          justifyContent: "flex-end",
        }}
      >
        <div
          style={{
            fontSize: "1rem",
          }}
        >
          {open ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1.7rem",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    height: "40px",
                    width: "40px",
                    position: "relative",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={window.location.origin + "/logo512.png"}
                    alt="Logo"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div
                  style={{
                    // @ts-ignore
                    textWrap: "wrap",
                  }}
                >
                  <h2
                    style={{
                      fontSize: ".9rem",
                    }}
                  >
                    Everest Billing System
                  </h2>
                  <p
                    className="sidebar-subtitle"
                    style={{
                      fontWeight: 400,
                      fontSize: ".6rem",
                    }}
                  >
                    {t("sidebar.subtitle")}
                  </p>
                </div>
              </div>
              <p
                style={{
                  marginTop: "15px",
                  margin: 0,
                  padding: 0,
                  textAlign: "center",
                  fontSize: ".8rem",
                }}
              >
                {new Date().getFullYear()} {t("sidebar.copyRight")}
              </p>
            </>
          ) : (
            <p
              style={{
                fontSize: "1.5rem",
                fontWeight: 500,
              }}
            >
              {t("sidebar.orgShortName")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
